export default ".avatar {\n  text-align: center;\n  overflow: hidden;\n}\n.avatar img {\n  vertical-align: top;\n}";